module.exports = __webpack_public_path__ + "static/media/acerca_00.79b4f820.jpg";